import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Theme } from "@/types";

interface SettingsState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      theme: "dark",

      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
    }),
    {
      name: "kiborg-settings",
      onRehydrateStorage: () => (state) => {
        // Re-apply theme on hydration
        if (state) applyTheme(state.theme);
      },
    }
  )
);

function applyTheme(theme: Theme) {
  const root = document.documentElement;
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const isDark = theme === "dark" || (theme === "system" && prefersDark);

  if (isDark) {
    root.removeAttribute("data-theme");
    root.classList.remove("light");
  } else {
    root.setAttribute("data-theme", "light");
    root.classList.add("light");
  }
}
